export const ENV_TEACHR = 'teachr';
export const ENV_VERIFIED_TRAINER = 'verifiedtrainer';
export const ENV_DECLARONS = 'declarons';
export const DEFAULT_BRAND = ENV_TEACHR;

// Lien vers l'académie Verified Trainer (espace communauté des coachs)
export const VERIFIED_TRAINER_ACADEMY_URL = 'https://academy.verified-trainer.com/community';

export const getActiveBrand = (): string => {
  return process.env.REACT_APP_BRAND || DEFAULT_BRAND;
};

export const isBrandActive = (brand: string): boolean => {
  return getActiveBrand() === brand;
};

/**
 * L'acompte (montant avancé par le client, attestation, preuves) n'existe pas
 * sur Verified Trainer : rien ne s'affiche ni ne se saisit sur cette marque.
 * La règle SCOOP par professeur reste gérée dans les formulaires.
 */
export const isDepositEnabled = (): boolean => !isBrandActive(ENV_VERIFIED_TRAINER);

export const getActiveBrandConfig = () => {
  const activeBrand = getActiveBrand();
  
  switch (activeBrand) {
    case ENV_VERIFIED_TRAINER:
      return 'verified-trainer';
    case ENV_DECLARONS:
      return 'declarons';
    case ENV_TEACHR:
    default:
      return 'teachr';
  }
};

export const getActivePrestataireBrandConfig = (value?: string) => {
  const activeBrand = getActiveBrand();
  
  switch (activeBrand) {
    case ENV_VERIFIED_TRAINER:
      return `coach${value ?? ''}`;
    case ENV_DECLARONS:
      return `prestataire${value ?? ''}`;
    case ENV_TEACHR:
    default:
      return `professeur${value ?? ''}`;
  }
};
export const getActivePrestationBrandConfig = (value?: string, valueTeachr?:string, valueVt?:string, valueAdd?:string) => {
  const activeBrand = getActiveBrand();
  
  switch (activeBrand) {
    case ENV_DECLARONS:
      return `${valueVt ?? ''}prestation${value ?? ''}`;
    default:
      return `${valueTeachr ?? ''}cours${valueAdd ?? ''}`;
  }
};
export const getActiveClientBrandConfig = (value?: string, valueTeachr?:string, valueVt?:string) => {
  const activeBrand = getActiveBrand();
  
  switch (activeBrand) {
    case ENV_TEACHR:
      return `${valueTeachr ?? ''}élève${value ?? ''}`;
    default:
      return `${valueVt ?? ''}client${value ?? ''}`;
  }
};
export const getPathClientBrandConfig = () => {  
  switch (getActiveBrand()) {
    case ENV_TEACHR:
      return `eleve`;
    default:
      return `client`;
  }
};

export const getActiveAppBrandConfig = () => {
  const activeBrand = getActiveBrand();
  
  switch (activeBrand) {
    case ENV_VERIFIED_TRAINER:
      return 'Verified Trainer';
    case ENV_DECLARONS:
      return 'Déclarons';
    case ENV_TEACHR:
    default:
      return "Teach'r";
  }
};


export const getUriAppBrandConfig = () => {
  return window.location.origin;
};





